// FO-022 (batch-15) — gedeelde request-schemas voor het tankpas-AI-inlezen.
// Eén bron voor API (`.safeParse`) + form (client-side validatie + inline veldfouten).

import { z } from 'zod'
import { idParam } from './id-validators'

/** Upload-payload: een PDF-factuur en/of een Excel/CSV-verbruiksbestand (base64). */
export const fuelImportUploadSchema = z
  .object({
    pdfBase64: z.string().optional(),
    verbruikBase64: z.string().optional(),
    verbruikBestandsnaam: z.string().max(255).optional(),
    bronBestandsnaam: z.string().max(255).optional(),
  })
  .refine(
    (v) => (v.pdfBase64 != null && v.pdfBase64.length > 0) || (v.verbruikBase64 != null && v.verbruikBase64.length > 0),
    { message: 'Lever een PDF-factuur en/of een verbruiksbestand (Excel/CSV) aan.', path: ['pdfBase64'] },
  )
export type FuelImportUploadInput = z.infer<typeof fuelImportUploadSchema>

/** Handmatige koppeling/correctie van een staging-regel vóór bevestigen. */
export const fuelImportRowPatchSchema = z.object({
  fuelCardId: idParam().nullable().optional(),
  voertuigId: idParam().nullable().optional(),
  bestuurderId: idParam().nullable().optional(),
  matchStatus: z.enum(['GEMATCHT', 'NIET_GEMATCHT', 'HANDMATIG']).optional(),
})
export type FuelImportRowPatchInput = z.infer<typeof fuelImportRowPatchSchema>

export const fuelImportVerwerpSchema = z.object({
  reden: z.string().trim().min(3, 'Geef een reden van minstens 3 tekens.').max(500),
})
export type FuelImportVerwerpInput = z.infer<typeof fuelImportVerwerpSchema>
